import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {makeGetInboxesById} from '../../../store/data/inboxes/inboxesSelectors';
import {getTeammatesInCommonTeam, getUser} from '../../../store/data/teammates/teammatesSelectors';
import {LensFormMultiSelectAssignees} from './lensFormMultiSelectAssignees';

/*
 * Props.
 */

interface LensFormMultiSelectAssigneesContainerProps {
  selectedInboxIds?: ReadonlyArray<number>;
}

/*
 * Selectors.
 */

function getSelectedInboxIds(_state: AppState, props: LensFormMultiSelectAssigneesContainerProps) {
  return props.selectedInboxIds ?? [];
}

const getInboxesInState = createSelector(
  [makeGetInboxesById(getSelectedInboxIds)],
  (inboxesInState) => inboxesInState,
);

const getTeammatesInCommon = createSelector(
  [getTeammatesInCommonTeam, getUser],
  (teammatesInCommon, user) => [user, ...teammatesInCommon],
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<LensFormMultiSelectAssigneesContainerProps>()(() => ({
  choices: getTeammatesInCommon,
  selectedInboxesInState: getInboxesInState,
}));

export const LensFormMultiSelectAssigneesContainer = connect(mapStateToProps)(LensFormMultiSelectAssignees);
